import { Card } from '../utils/CardUtils';
import { Meld } from './Meld';
import { PLAYER_ID } from '../utils/Constants';

export type TurnPhase = 'draw' | 'meld' | 'discard' | 'round_end' | 'game_over';

export interface PlayerState {
  id: string;
  hand: Card[];
  melds: Meld[];
  tookPozzetto: boolean;
  totalScore: number;
}

export interface GameState {
  players: [PlayerState, PlayerState];
  drawPile: Card[];
  discardPile: Card[];
  pozzetti: [Card[] | null, Card[] | null]; // null = taken
  currentPlayerIndex: number;
  turnPhase: TurnPhase;
  roundNumber: number;
  stalemateTurnCount: number;
  hasDrawnThisTurn: boolean;
  hasMeldedThisTurn: boolean;
  roundScores: { player0: number; player1: number }[];
  winner: string | null;
}

export function createInitialGameState(): GameState {
  return {
    players: [
      {
        id: PLAYER_ID.HUMAN,
        hand: [],
        melds: [],
        tookPozzetto: false,
        totalScore: 0,
      },
      {
        id: PLAYER_ID.AI,
        hand: [],
        melds: [],
        tookPozzetto: false,
        totalScore: 0,
      },
    ],
    drawPile: [],
    discardPile: [],
    pozzetti: [null, null],
    currentPlayerIndex: 0,
    turnPhase: 'draw',
    roundNumber: 1,
    stalemateTurnCount: 0,
    hasDrawnThisTurn: false,
    hasMeldedThisTurn: false,
    roundScores: [],
    winner: null,
  };
}

export function getCurrentPlayer(state: GameState): PlayerState {
  return state.players[state.currentPlayerIndex];
}

export function getOpponent(state: GameState): PlayerState {
  return state.players[1 - state.currentPlayerIndex];
}

export function isHumanTurn(state: GameState): boolean {
  return state.currentPlayerIndex === 0;
}
